export const booleanOptions = [
  { key: 'true', text: 'true', value: true },
  { key: 'false', text: 'false', value: false },
];
